import React, {Component} from "react";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {fetchDataAsync, FormatCurrencyWithoutSymbol} from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../common/mapper";
import {HttpStatus} from "../../../../common/Constants";
import * as R from "ramda";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {listBbmColumns} from "../config";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";

class ListBbm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            specialCategoryOptions: [],
            specialCategory: null,
            dataTable: [],
            totalData: 0,
            selectedBBM: null,
            tableColumns: [],
            alertCanUse: false,
            alertCannotUse: false,
            amountToPay: 0,
            selectedJpTac: null,
        };
    };

    componentDidMount = async () => {
        this.handleTriggerLoading();
        let {jpTac, data} = this.props;
        let amountToPay =
            R.equals(jpTac, "jpTac1Bbm")
                ? data?.jpTac1TransferredAmount || 0
                : R.equals(jpTac, "jpTac2Bbm")
                    ? data?.jpTac2TransferredAmount || 0
                    : R.equals(jpTac, "jpTac3Bbm") 
                    ? data?.jpTac3TransferredAmount || 0 : data?.leasingOtherTransferredPayment || 0;
        let selectedJpTac =
            R.equals(jpTac, "jpTac1Bbm")
                ? "JP/TAC 1 Transfer"
                : R.equals(jpTac, "jpTac2Bbm")
                    ? "JP/TAC 2 Transfer"
                    : R.equals(jpTac, "jpTac3Bbm") 
                    ? "JP/TAC 3 Transfer" 
                    : "Lain-Lain Transfer";
        this.setState((prevState) => ({
            ...prevState,
            tableColumns: this.getTableColumns(),
            amountToPay,
            selectedJpTac,
        }));
        await this.fetchSpecialCategory();
        await this.fetchData(this.state.specialCategory);
        this.handleTriggerLoading();
    }

    getTableColumns = () => {
        let columns = [...listBbmColumns];
        columns.push({
            name: "nomorBBM",
            label: "Aksi",
            options: {
                customBodyRender: (val) => {
                    return (<SimpleButton onClick={() => this.handleSelectBBM(val)}>
                        Pilih
                    </SimpleButton>)
                },
                sort: false,
            },
        });
        return columns;
    };

    handleSelectBBM = async (val) => {
        let {dataTable} = this.state;
        let bbm = dataTable.find(item => item.nomorBBM === val);
        await this.setState((prevState) => ({
            ...prevState,
            selectedBBM: bbm,
        }));
        this.handleCanUseVisibility();
    };

    handleSubmit = () => {
        this.handleCanUseVisibility();
        let {selectedBBM, amountToPay} = this.state;
        if (amountToPay > selectedBBM.sisaAmount) {
            this.handleCannotUseVisibility();
        } else {
            this.props.handleSubmit(selectedBBM.nomorBBM);
        }
    };

    handleCanUseVisibility = () => {
        this.setState((prevState) => ({...prevState, alertCanUse: !prevState.alertCanUse}));
    };

    handleCannotUseVisibility = () => {
        this.setState((prevState) => ({...prevState, alertCannotUse: !prevState.alertCannotUse}));
    };

    fetchData = async (specialCategory) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getBBMForPaymentLeasing,
            menuName: "List Table BBM",
            setError: this.props.setError,
            args: {
                specialCategory: specialCategory || "",
                kodeCabang: this.props.kodeCabang,
            },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                dataTable: res.data.data,
                totalData: res.data.totalData,
            }))
        }
    };

    fetchSpecialCategory = async () => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizparByParam,
            menuName: "List Table BBM",
            setError: this.props.setError,
            args: {
                paramFilters: {
                    bizparCategory: "PAYMENT_SPECIAL_CATEGORY",
                    status: "ACTIVE",
                },
            },
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevState) => ({
                ...prevState,
                specialCategoryOptions: res.data.data.map(item => mapToObjectDDL(item.value, item.key)),
            }))
        }
    };

    handleChangeSpecialCategory = async (value) => {
        this.setState((prevState) => ({
            ...prevState,
            specialCategory: value,
        }));
        this.handleTriggerLoading();
        await this.fetchData(value?.value || null);
        this.handleTriggerLoading();
    };

    handleTriggerLoading = () => {
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
    };

    render() {
        let {selectedBBM, selectedJpTac} = this.state;
        return (
            <>
                <SimpleModal
                    title="List Table BBM"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose(null)}
                    content={
                        <ModalContainer>
                            <SimpleDDL
                                box="search"
                                isClearable
                                id="select_options_special_category"
                                options={this.state.specialCategoryOptions}
                                value={this.state.specialCategory}
                                onChange={(value) => this.handleChangeSpecialCategory(value)}
                            />
                            <SimpleDataTable
                                data={this.state.dataTable}
                                columns={this.state.tableColumns}
                                toCount={this.state.totalData}
                                rowsPerPage={5}
                                page={0}
                                options={{serverSide: false}}
                            />
                        </ModalContainer>
                    }
                />
                {this.state.alertCanUse && (
                    <SimpleAlert
                        visible={this.state.alertCanUse}
                        title="Information"
                        onClickClose={this.handleCanUseVisibility}
                        content={
                            <FlexView column hAlignContent="left" style={{gap: 10}}>
                                <p>Nilai No BBM sudah dipakai sebesar
                                    Rp.{FormatCurrencyWithoutSymbol({number: selectedBBM.totalAmount - selectedBBM.sisaAmount})}</p>
                                <p>{selectedJpTac}</p>
                                <p>Akan dianggap LUNAS dengan menggunakan No BBM</p>
                                <p>{selectedBBM.nomorBBM}</p>
                                <p>Apakah anda yakin?</p>
                            </FlexView>
                        }
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleCanUseVisibility}>Batal</SimpleButton>
                                <SimpleButton onClick={this.handleSubmit}>Iya</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.alertCannotUse && (
                    <SimpleAlert
                        visible={this.state.alertCannotUse}
                        title="Information"
                        onClickClose={this.handleCannotUseVisibility}
                        content={`Nilai sisa No BBM tidak dapat digunakan untuk melunasi ${selectedJpTac}. Silakan pilih No BBM lain.`}
                        additionalButtons={
                            <FlexView vAlignContent="right" style={{gap: "10px"}}>
                                <SimpleButton onClick={this.handleCannotUseVisibility}>OK</SimpleButton>
                            </FlexView>
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

export default ListBbm;